import { useEffect } from "react";
import { BreadcrumbJsonLd } from "next-seo";

export default function Breadcrumb(props) {
  useEffect(() => {});

  return (
    <>
      {!props.name3&&<BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: `${props.name1}`, item: `${props.link1}` },
          { position: 2, name: `${props.name2}`, item: `${props.link2}` }
        ]}
        
      />}

      {props.name3&&!props.name4&&<BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: `${props.name1}`, item: `${props.link1}` },
          { position: 2, name: `${props.name2}`, item: `${props.link2}` },
          { position: 3, name: `${props.name3}`, item: `${props.link3}` },
        ]}
        
      />}
      {props.name4&&<BreadcrumbJsonLd
        itemListElements={[
          { position: 1, name: `${props.name1}`, item: `${props.link1}` },
          { position: 2, name: `${props.name2}`, item: `${props.link2}` },
          { position: 3, name: `${props.name3}`, item: `${props.link3}` },
          { position: 4, name: `${props.name4}`, item: `${props.link4}` },
        ]}
        
      />}


    </>
  );
}
